import { TopPageIndustry } from '@/common/types'

const getIndustryBackground = (rgbaColor: string): string => {
  return `linear-gradient(180deg, ${rgbaColor} 0%, rgba(255, 255, 255, 0.1) 67.08%), #FFFFFF`
}

export const TOP_PAGE_ID = 0
const WORK_INDUSTRY_ID = 1
const MEDICAL_INDUSTRY_ID = 2
const SERVICE_INDUSTRY_ID = 3
const OFFICE_INDUSTRY_ID = 4
export const CASUAL_INDUSTRY_ID = 5

export const topIndustries: TopPageIndustry[] = [
  {
    id: WORK_INDUSTRY_ID,
    displayName: '現場作業・工場',
    industryName: 'work',
    href: '/industries/work',
    topImageSrc: require('top_page/top-industry-work.svg'),
    industryImageSrc: require('top_page/industry-work.svg'),
    background: getIndustryBackground('rgba(33, 166, 111, 0.1)'),
    description: '現場作業・工場で使う作業着、作業服ならラクスルのアパレル・ユニフォーム。ワークジャケットやブルゾン・ジャンパーから、防寒用のアウター、ポロシャツなど、様々な商品を取り揃えています。もちろん名入れなどの刺繍・プリント加工が可能で、初めての方でもデザイン画面から簡単にオリジナルの服を作れます。しかも1枚から全国送料無料でお届けします。',
    keywords: [
      '空調服 ファン付き マウンテンパーカー',
      '空調服 ファン付き ブルゾン',
      '空調服 ファン付き ベスト',
      '空調服 ファン付き スターターキット',
      '空調服 インナー',
      'ワークマン 介護服',
      '作業着 ストレッチ',
      'つなぎ服',
      '夏用 作業着',
      '作業 着 女性 可愛い',
      '防寒 ジャンパー',
      '防寒 ズボン',
      '雨合羽',
      'ワークマン 防寒着',
      'デニム 作業着'
    ]
  },
  {
    id: MEDICAL_INDUSTRY_ID,
    displayName: '医療・看護・介護',
    industryName: 'medical',
    href: '/industries/medical',
    topImageSrc: require('top_page/top-industry-medical.svg'),
    industryImageSrc: require('top_page/industry-medical.svg'),
    background: getIndustryBackground('rgba(41, 150, 204, 0.1)'),
    description: '医療・看護・介護で使う制服・ユニフォームならラクスルのアパレル・ユニフォーム。スクラブ・ケーシ、チュニックから、ドクターコート（白衣）、介護用のエプロンまで、様々な商品を取り揃えています。もちろん名入れなどの刺繍・プリント加工が可能で、初めての方でもデザイン画面から簡単にオリジナルの服を作れます。しかも1枚から全国送料無料でお届けします。',
    keywords: [
      'スクラブ 医療',
      'エステ ユニフォーム',
      'ナース ウェア',
      '医師 スクラブ かっこいい'
    ]
  },
  {
    id: SERVICE_INDUSTRY_ID,
    displayName: '飲食・サービス',
    industryName: 'service',
    href: '/industries/service',
    topImageSrc: require('top_page/top-industry-service.svg'),
    industryImageSrc: require('top_page/industry-service.svg'),
    background: getIndustryBackground('rgba(242, 182, 0, 0.1)'),
    description: '飲食・サービス業で使う制服・ユニフォームならラクスルのアパレル・ユニフォーム。カフェで使えるエプロンから和食店用の前掛け、きれいめのシャツ、コックコートまで、様々な商品を取り揃えています。もちろん名入れなどの刺繍・プリント加工が可能で、初めての方でもデザイン画面から簡単にオリジナルの服を作れます。しかも1枚から全国送料無料でお届けします。',
    keywords: [
      '厨房服',
      'カフェ エプロン',
      '割烹 着'
    ]
  },
  {
    id: OFFICE_INDUSTRY_ID,
    displayName: 'カジュアル・オフィス',
    industryName: 'office',
    href: '/industries/casual',
    topImageSrc: require('top_page/top-industry-office.svg'),
    industryImageSrc: require('top_page/industry-office.svg'),
    background: getIndustryBackground('rgba(208, 2, 27, 0.1)'),
    description: 'カジュアル・スポーツで使えるオリジナルユニフォーム、オフィスで使える制服ならラクスルのアパレル・ユニフォーム。定番のTシャツ、ポロシャツ、スウェット・パーカーから、フォーマルな事務服まで、様々な商品を取り揃えています。もちろん名入れなどの刺繍・プリント加工が可能で、初めての方でもデザイン編集画面から簡単にオリジナルの服を作れます。しかも1枚から全国送料無料でお届けします。',
    keywords: [
      '事務服',
      '事務 服 ブラウス',
      '開襟 シャツ',
      'ポロシャツ レディース',
      'アロハ シャツ'
    ]
  }
]

export const firstViewedBrands: { [key: string]: string[] } = {
  [TOP_PAGE_ID]: [
    'midori-anzen',
    'nagai-leben',
    'ts-design',
    'arbe',
    'burtle',
    'face-mix',
    'printstar',
    'glimmer',
    'united-athle',
    'unite-mizuno',
    'unite-michelklein',
    'kuchofuku',
    'folk',
    'champion',
    'bees-beam',
    'cross-and-stitch',
    'truss',
    'wacoal-HI-collection',
    'heartgreen',
    'kazen',
    'montblanc',
    'servo',
    'asics',
    'aitoz'
  ],
  [WORK_INDUSTRY_ID]: [
    'midori-anzen',
    'ts-design',
    'burtle',
    'rocky',
    'kuchofuku',
    'carean',
    'aitoz',
    'kokuraya'
  ],
  [MEDICAL_INDUSTRY_ID]: [
    'midori-anzen',
    'nagai-leben',
    'calala',
    'unite',
    'unite-mizuno',
    'unite-michelklein',
    'folk',
    'pantone',
    'dickies',
    'wacoal-HI-collection',
    'heartgreen',
    'kazen',
    'montblanc',
    'servo',
    'asics',
    'laura-ashley',
    'o-c-m-d',
    'flab',
    'zipscrub',
    'aitoz'
  ],
  [SERVICE_INDUSTRY_ID]: [
    'arbe',
    'natural-smile',
    'face-mix',
    'kazen',
    'montblanc',
    'servo',
    'aitoz'
  ],
  [OFFICE_INDUSTRY_ID || CASUAL_INDUSTRY_ID]: [
    'calala',
    'bonoffice',
    'boncierge',
    'printstar',
    'glimmer',
    'united-athle',
    'nuovo',
    'champion',
    'descente',
    'converse',
    'new-balance',
    'newhattan',
    'jerzees',
    'bees-beam',
    'cross-and-stitch',
    'truss',
    'food-textile',
    'seventeen-verglebee',
    'fruit-of-the-loom',
    'orgabits',
    'otto',
    'pbr-zero',
    'enjoy',
    'enjoy-noir',
    'amus-net',
    'aitoz',
    'kokuraya'
  ]
}
